class SkuCombo {
  id = null;
  name = null;
  status = null;
  originalStatus = null;
  code = null;
  orgPrice = null;
  comboPrice = null;
  transactionStatus = null;
  cardDisplayName = null;
  comboItems = [];
  // type = 'duo';

  constructor(data) {
      this.id = data.id ?? null;
      this.code = data.code ?? null;
      this.name = data.name ?? null;
      this.status = data.status ?? null;
      this.originalStatus = data.originalStatus ?? null;
      this.orgPrice = data.orgPrice ?? 0;
      this.comboPrice = data.comboPrice ?? 0;
      this.transactionStatus = data.transactionStatus ?? null;
      this.cardDisplayName = data.cardDisplayName ?? null;
      this.comboItems = data.comboItems ?? [];
      // this.type =  'duo';
  }
}

export default SkuCombo;